import { render, staticRenderFns } from "./setPrivilegeUser.vue?vue&type=template&id=0bb66ae0&scoped=true&"
import script from "./setPrivilegeUser.vue?vue&type=script&lang=js&"
export * from "./setPrivilegeUser.vue?vue&type=script&lang=js&"
import style0 from "./setPrivilegeUser.vue?vue&type=style&index=0&id=0bb66ae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb66ae0",
  null
  
)

export default component.exports